import { useMutation, useQueryClient } from "@tanstack/react-query";
import { SocialRegistrationDesktopArgs, registerSocialDesktop } from "../../apis/auth";
import { userFromResponse } from "../../types/user";
import { Storage } from "../../storage";

export function useRegisterSocialDesktop() {
  const queryClient = useQueryClient();
  const { mutate, error, status, data } = useMutation({
    mutationFn: (data: SocialRegistrationDesktopArgs) => {
      return registerSocialDesktop(data);
    },
    onSuccess: (data) => {
      const user = userFromResponse(data.data);
      if (user) {
        Storage.setCurrentUser(JSON.stringify(user));
        queryClient.invalidateQueries({ queryKey: ["userSync"] });
      }
    },
  });

  return {
    registerSocialDesktop: mutate,
    error,
    status,
    isLoading: status === "pending",
    data,
  };
}
